/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { CobraWhoamiRequest } from '../types/CobraWhoami';
import type { CobraWhoamiResponse } from '../types/CobraWhoami';

export type CobraWhoamiCreateRequest = CobraWhoamiRequest;
export type CobraWhoamiCreateResponse = CobraWhoamiResponse;

export type CobraWhoamiCreateQuery = {};

/**
 * POST /dmx-server/cobra-whoami/
 *
 * ```yaml
 * operationId: cobra_whoami_create
 * description: |-
 *   Takes a token and indicates if it is valid.  This view provides no
 *   information about a token's fitness for a particular use.
 * tags:
 *   - cobra-whoami
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/CobraWhoami'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/CobraWhoami'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/CobraWhoami'
 *   required: true
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/CobraWhoami'
 *     description: ''
 * ```
 */
export const cobraWhoamiCreateOperation = (rest?: CobraWhoamiCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/cobra-whoami/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/cobra-whoami/' };
  };

/**
 * POST /dmx-server/cobra-whoami/
 *
 * ```yaml
 * operationId: cobra_whoami_create
 * description: |-
 *   Takes a token and indicates if it is valid.  This view provides no
 *   information about a token's fitness for a particular use.
 * tags:
 *   - cobra-whoami
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/CobraWhoami'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/CobraWhoami'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/CobraWhoami'
 *   required: true
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/CobraWhoami'
 *     description: ''
 * ```
 */
export const cobraWhoamiCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: CobraWhoamiCreateQuery;
  request: CobraWhoamiRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<CobraWhoamiResponse>> => {
  const operation = cobraWhoamiCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
